import React from 'react';
import { updateUserAccount } from '../../../sp-firebase/userFB';
import { SpotLockUser } from '../../../sp-types/userType';
import { CURRENT_USE_CASES } from './TopBar';
import { LoadingSpinnerOverlay } from '../../UI-Elements/LoadingSpinnerOverlay';

interface CaseSwitchProps {
  states: string[];
  selectedState: string;
  setState: React.Dispatch<React.SetStateAction<string>>;
  userData: SpotLockUser;
}

export const CaseSwitchers: React.FC<CaseSwitchProps> = ({ selectedState, setState, states, userData }) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const switchAccount = async (toAccount: string) => {
    setIsLoading(true);
    await updateUserAccount(userData?.id, toAccount);
    window.location.reload();
  };

  const onStateClick = (state: string) => {
    if (selectedState !== state) {
      setState(state);
      switchAccount(CURRENT_USE_CASES[state]?.account || '');
    }
  };

  return (
    <div className="relative flex flex-row max-h-10 overflow-auto ">
      {states.map((item, index) => (
        <button
          key={index}
          style={{ border: '1px solid #6571ff' }}
          className={`h-9 px-6 text-blue-600 text-sm font-medium    ${index === 0 && 'rounded-l-3xl'} ${
            states.length - 1 === index && 'rounded-r-3xl'
          } ${item === selectedState ? 'bg-blue-600 text-white' : 'bg-white text-blue-600'} `}
          onClick={() => onStateClick(item)}
        >
          {item}
        </button>
      ))}
      {isLoading && <LoadingSpinnerOverlay size={30} />}
    </div>
  );
};
